import { html, type TemplateResult } from "lit";
import { ApiError } from "../services/apiError.js";
import "../design-system/cos-empty-state.js";

// The two plain sentences a librarian sees when Digital Archives is not for
// them: the library does not have it (Preserve decision 2, 1 November 2026),
// or the login is restricted library staff (level 4), who wait for per-person
// permissions. One place, so every Preserve screen says the same thing.

export const NOT_SUBSCRIBED_SENTENCE = "Your library does not have Digital Archives.";
export const ADMINS_ONLY_SENTENCE = "Digital Archives is available to your library's administrators.";

/** The screen for a library without the Preserve subscription. */
export function renderNotSubscribed(): TemplateResult {
	return html`<cos-empty-state title=${NOT_SUBSCRIBED_SENTENCE}></cos-empty-state>`;
}

/** The screen for a restricted (level 4) library login. */
export function renderAdminsOnly(): TemplateResult {
	return html`<cos-empty-state title=${ADMINS_ONLY_SENTENCE}></cos-empty-state>`;
}

/** True for the server's refusal of a library without the subscription: a
 *  403 whose message says the library does not have Preserve. Detected by
 *  status and message, never by a substring of the whole error string. */
export function isNotSubscribedError(err: unknown): boolean {
	return err instanceof ApiError && err.status === 403 && /does not have Preserve/i.test(err.message);
}
